const Plus = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.8334 14.8332H14.8334V25.8332H11.1667V14.8332H0.166748V11.1665H11.1667V0.166504H14.8334V11.1665H25.8334V14.8332Z" fill="#010101" />
  </svg>)

export default Plus